import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { PRICING } from "../../lib/site";
import { scrollToId, BrutalButton } from "./shared";

export function MobileCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }} animate={{ y: 0 }} exit={{ y: 90 }}
          transition={{ type: "spring", damping: 22, stiffness: 260 }}
          className="lg:hidden fixed bottom-0 inset-x-0 z-[70] bg-white border-t-2 border-brand-black px-4 py-3 flex items-center justify-between gap-3"
          data-testid="mobile-cta"
        >
          <div>
            <p className="font-bold text-[13px] leading-tight">YouTube Lead Gen Mastery</p>
            <p className="font-display text-lg leading-none text-brand-blue">₹{PRICING.current}</p>
          </div>
          <BrutalButton onClick={() => scrollToId("pricing")} variant="red" className="!min-h-[46px] !px-6" data-testid="mobile-cta-button">
            View Offer
          </BrutalButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 1200);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 lg:bottom-6 right-4 sm:right-6 z-[70] h-12 w-12 rounded-full bg-brand-black text-white border-2 border-brand-black flex items-center justify-center hover:bg-brand-blue transition-colors"
          aria-label="Back to top" data-testid="back-to-top"
        >
          <ArrowUp size={20} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
